// file: assets/js/cards.js

export function draw_lob_cards(data) {

	console.log(data);
	// 1) Clear the container
	const $cardsContainer = $('#cards');
	$cardsContainer.empty();

	if (!Array.isArray(data) || !data.length) {
		$cardsContainer.append('<div>No lines of business found.</div>');
		return;
	}

	// 2) Create a wrap
	const $cardAreaWrap = $('<div class="card_area_wrap"></div>');

	// 3) Loop and build cards
	data.forEach(lob => {
		// Extract data fields
		const lineName        = lob.title || '---';
		const insuredName     = lob.company_name || '---';
		const dateSubmitted   = lob.added_formatted_date || '---';
		const controlNumber   = lob.control_number || '---';
		const nrQuoteNumber   = lob.nr_quote_number || '---';
		const EffectiveDate   = lob.EffectiveDate || '---';
		const stateName       = lob.state_code || '---';
		const leadId          = lob.lead_id || '---';  // adjust if you have lead_id in the object
		const lineId          = lob.line_id || 1;  // adjust if you have lead_id in the object

		// Build the HTML markup for the card
		const $cardItem = $(`
      <div class="card_item_wrap">
        <h5 class="line">${lineName}</h5>
        <div class="title InsuredName">${insuredName}</div>

        <div class="row DateSubmitted">
          <label>Submitted:</label>
          <span class="IMSDateSubmittedValue">${dateSubmitted}</span>
        </div>

        <div class="row IMSControlNumber">
          <label>IMS Control #:</label>
          <span class="IMSControlNumberValue">${controlNumber}</span>
        </div>

        <div class="row EffectiveDate">
          <label>Eff. Date:</label>
          <span class="EffectiveDateValue">${EffectiveDate}</span>
        </div>

        <div class="row NRQuoteId">
          <label>NR Quote ID:</label>
          <span class="NRQuoteIdValue">${nrQuoteNumber}</span>
        </div>

        <div class="row State">
          <label>State:</label>
          <span class="StateValue">${stateName}</span>
        </div>

        <!-- Action button + loading spinner -->
        <div class="nrActions">
          <button type="button" class="btnNrQuote">NetRate Quote</button>
          <span class="loadingIndicator" style="display:none;margin-left:10px;">Loading...</span>
        </div>
      </div>
    `);

		// 4) Add click handler for "NetRate Quote" button
		$cardItem.find('.btnNrQuote').on('click', function() {
			const $btn       = $(this);
			const $spinner   = $cardItem.find('.loadingIndicator');
			const $nrQuoteId = $cardItem.find('.NRQuoteIdValue');

			// Show loading
			$spinner.show();
			$btn.prop('disabled', true);

			// Build data or URL for your AJAX
			// Example: /ims_export/netRateQuote/<leadId>
			// We'll POST line_id=2 (MTC) and control_number
			const url = `/ims_export/netRateQuote/${leadId}`;
			const postData = {
				line_id: lineId,                // example: MTC
				control_number: controlNumber
			};

			$.ajax({
				url: url,
				type: 'POST',
				data: postData,
				dataType: 'json',
				success: function(resp) {
					console.log('Server response:', resp);
					if (resp && resp.nr_quote_number) {
						// Update UI with new quote number
						$nrQuoteId.text(resp.nr_quote_number);
					} else {
						alert('No nr_quote_number returned from server.');
					}
				},
				error: function(xhr, status, error) {
					console.error('AJAX error:', status, error);
					alert('Failed to create NetRate Quote. Please check logs or try again.');
				},
				complete: function() {
					// Hide loading, re-enable
					$spinner.hide();
					$btn.prop('disabled', false);
				}
			});
		});

		// Append to card_area_wrap
		$cardAreaWrap.append($cardItem);
	});

	// 5) Append everything to #cards
	$cardsContainer.append($cardAreaWrap);
}
